import React from 'react'
import {Link} from 'react-router-dom'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import {setSessionToken} from 'Skelet/src/modules/fetch.action.js'
import {toggleDropdown, openModal, closeModal} from 'Skelet/src/modules/functions.js'
import ModalLabels from 'Skelet/src/components/ModalLabels.js'


class CoreRouteHeader extends React.Component {

  constructor(props) {
    super(props);
    this.state = {dropdown_open:false, is_scrolling:false};

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    document.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    document.removeEventListener('scroll', this.handleScroll);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(e) {
    if(this.wrapperRef && !this.wrapperRef.contains(e.target)) {
      this.setState({dropdown_open:false});
    }
  }

  handleScroll(e) {
    if(window.pageYOffset === 0) {
      this.setState({is_scrolling:false});
    } else {
      this.setState({is_scrolling:true});
    }
  }

  render() {
    return (
      <header className={this.state.is_scrolling ? "scrolling" : null}>
      <div className="container">
        <div className="primary">
          <Link to="/" className="logo">DEX by Polymedia</Link>
        </div>
        <div className="secondary">
          <nav className="navigation">
            <ol>
              <li className={"nav-item" + ((this.props.pathname === "/pipelines") ? " current" : "")}><Link to="/pipelines">Pipelines</Link></li>
              <li className={"nav-item" + ((this.props.pathname === "/") ? " current" : "")}><Link to="/">Contacts</Link></li>
              <li className={"nav-item dropdown" + ((this.state.dropdown_open) ? " open" : "")} ref={this.setWrapperRef}>
                <Link to="/settings" className="btn dropdown-toggle" onClick={(e) => toggleDropdown(this, e)}>
                  <span>{this.props.account_data.firstname[0]}</span>
                </Link>
                <div className="dropdown-menu">
                  <div className="dropdown-caret">
                    <span className="caret-outer"></span>
                    <span className="caret-inner"></span>
                  </div>
                  <ul>
                    <li className="sub-item highlight">
                      <Link to="/settings" onClick={() => toggleDropdown(this)}><b>{this.props.account_data.firstname}</b><p>Settings</p></Link>
                    </li>
                    <li className="dropdown-divider"></li>
                    <li className="sub-item"><Link to="/" onClick={(e) => {toggleDropdown(this);openModal(this, e)}}>Labels</Link></li>
                    <li className="dropdown-divider"></li>
                    <li className="sub-item"><Link to="/start" target="_blank" onClick={() => toggleDropdown(this)}>Start</Link></li>
                    <li className="dropdown-divider"></li>
                    <li className="sub-item"><Link to="/" onClick={this.props.logOut}>Log out</Link></li>
                  </ul>
                </div>
              </li>
            </ol>
          </nav>
        </div>
      </div>
      <ModalLabels lang="EN" config={this.props.config} shouldShow={this.state.modal_open} close={() => closeModal(this)} />
      </header>
    );
  }

}


function mapStateToProps(state) {
  let account_data = null;
  if(state.apiData["login"] !== undefined && state.apiData["login"]["data"]["token"] !== undefined) {
    account_data = state.apiData["login"]["data"];
  }
  return {
    account_data: account_data,
    pathname: state.router.location.pathname,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    logOut: () => {document.getElementById("main").scrollIntoView(true);return setSessionToken(null)},
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CoreRouteHeader)



// WEBPACK FOOTER //
// ./src/containers/route-containers/CoreRouteHeader.js